import Footer from 'src/components/UCA/Footer';
import Header from 'src/components/UCA/Header';
import List from 'src/components/UCA/List';
import ListItem from 'src/components/UCA/ListItem';
import SectionPage from 'src/components/UCA/SectionPage';
import { FOOTER_DETAILS, HEADER_DETAILS } from 'src/data/PowerOfAssessors/constant';

export default function PowerOfAssessors() {
  return (
    <SectionPage>
      <Header {...HEADER_DETAILS} />
      <div className="list-none p-0 px-10 pt-4">
        <List prefix="1">
          <ListItem prefix="a">
            The county assessor may request a signed statement from any person setting forth all the
            real and personal property assessable by the assessor which is owned, possessed,
            managed, or under the control of the person at 12 noon on January 1.
          </ListItem>
          <ListItem prefix="b">
            A request under Subsection (1)(a) shall invlude a notice of the procedure under Section
            59-2-1005 for appealing the value of the personal property
          </ListItem>
        </List>
        <List prefix="2">
          <ListItem prefix="a">
            Except as provided in Subsection (2)(b) or (c), a signed statement described in
            Subsection (1) shall be filed on or before May 15 of the year the statement described in
            Subsection (1) is requested by the county assessor.
          </ListItem>
          <ListItem prefix="b">
            For a county of the first class, the signed statement described in Subsection (1) shall
            be filed on the later of:
            <List level="1">
              <ListItem prefix="i">60 days after requested by the assessor; or</ListItem>
              <ListItem prefix="ii">
                on or before May 15 of the year the statement described in Subsection (1) is
                requested by the county assessor if, by resolution, the county legislative body of
                that county adopts the deadline described in Subsection (2)(a).
              </ListItem>
            </List>
          </ListItem>
          <ListItem prefix="c">
            If a county assessor requests a signed statement described in Subsection (1) on or after
            March 16, the person shall file the signed statement within 60 days after requested by
            the assessor
          </ListItem>
        </List>
        <ListItem prefix="3">
          The signed statement shall include the following:
          <List level="2">
            <ListItem prefix="a">
              all property belonging to, claimed by, or in the possession, control, or management of
              the person, any firm of which the person is a member, or any coportation of which the
              person is president, secretary, cashier, or managing agent;
            </ListItem>
            <ListItem prefix="b">
              the county in which the property is located or in which it is taxable; and, if taxable
              in the county in which the signed statement was made, also the city, town, school
              district, road district, or other taxing district in which it is located or taxable;
            </ListItem>
            <ListItem prefix="c">
              all lands in parcels or subdivisions not exceeding 640 acres each, the sections and
              fractional sections of all tracts of land containing more than 640 acres which have
              been sectionized by the United States government, and the improvements on those lands;
              and
            </ListItem>
            <ListItem prefix="d">
              for a person who owns taxable tangible personal property as defined in Section
              59-2-1115, the person&apos;s NAICS code, as classified under the current North
              American Indistry Classification System of the federal Executive Office of the
              President, Office of Management and Budget.
            </ListItem>
          </List>
        </ListItem>
        <ListItem prefix="4">
          Every assessor may subpoena and examine any person in an county in relation to any signed
          statement by may not required that person to appear in any county other than the county in
          which the subpoena is served.
        </ListItem>
      </div>
      <Footer {...FOOTER_DETAILS} />
    </SectionPage>
  );
}
